<template>
  <b-container>
    <!-- <h2>{{ model.processName }}</h2> -->
    <!-- <b-button size="sm">{{ $t("geral.delete") }}</b-button> -->
    <b-row>
      <b-col lg="6" md="6" sm="12" class="div-row-padding">
        <b-form-group label="Status" label-for="input-process-displayName">
          <b-form-select
            :options="optionsStage"
            v-model="model.statusId"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-for="field in processValues" :key="field.fieldId">
      <b-col>
        <workflow-fill-field
          :field="field"
          :fieldId="field.fieldId"
          :modelstate="modelstate"
          :stage="false"
        ></workflow-fill-field>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "ProcessFilled",
  props: {
    readonly: Boolean,
    model: Object,
    modelstate: Object,
    optionsStage: Array,
    originalStatus: String,
  },

  components: {
    WorkflowFillField: () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  created() {},
  computed: {
    statusIdComputed() {
      return this.model.statusId;
    },
    processValues() {
      let fields = [];
      if (this.model != null) {
        if (this.model.values) {
          for (let field of this.model.values) {
            fields.push(field);
          }
        }
        if (this.model.additionalFields) {
          for (let field of this.model.additionalFields) {
            fields.push(field);
          }
        }
      }
      return fields.sort((a1, a2) => a1.sequenceNumber < a2.sequenceNumber);
    },
  },
  data() {
    return {};
  },
  methods: {
    getAdditionalFields() {
      if (!this.model) return;
      if (!this.model.id) return;
      if (!this.model.statusId) return;
      this.$apiWorkflow
        .get("/addtionalFields/" + this.model.statusId + "/" + this.model.id)
        .then((response) => {
          console.log("response");
          console.log(response.data);
          let additionalFieldsNew = [];
          let additionalFieldsResponse = response.data;
          if (additionalFieldsResponse) {
            for (let additionalField of additionalFieldsResponse) {
              if (
                !this.model.values.some(
                  (e) => e.fieldId == additionalField.fieldId
                )
              ) {
                additionalFieldsNew.push(additionalField);
              }
            }
          }
          this.model.additionalFields = additionalFieldsNew;
        });
    },
  },
  watch: {
    statusIdComputed() {
      if (this.model.statusId != this.originalStatus) {
        this.getAdditionalFields();
      }
    },
  },
};
</script>
